import { memo } from 'react';
import { useChatContext } from '../../../../contexts/chat/chat.context';
import { ChatViewType } from '../../../../contexts/chat/reducer/chatReducer.types';
import ChatFormHeader from './components/ChatFormHeader/ChatFormHeader';
import ChatGroupedRoomsHeader from './components/ChatGroupedRoomsHeader/ChatGroupedRoomsHeader';
import ChatRoomsHeader from './components/ChatRoomsHeader/ChatRoomsHeader';

const ChatContainerHeader = () => {
  const { view } = useChatContext();

  switch (view.type) {
    case ChatViewType.GroupedRooms:
      return <ChatGroupedRoomsHeader />;
    case ChatViewType.RoomsOfGroup:
      return <ChatRoomsHeader />;
    case 'private-creation':
    case 'group-creation':
      return <ChatFormHeader />;
    default:
      return null;
  }
};

export default memo(ChatContainerHeader);
